import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from 'recharts'
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/shared/components/ui/chart'

const chartConfig = {
  total: { label: 'Inscritos', color: '#8b5cf6' },
} satisfies ChartConfig

interface InscripcionesChartProps {
  data: { fecha: string; total: number }[]
}

export function InscripcionesChart({ data }: InscripcionesChartProps) {
  const last30 = data.slice(-30)

  return (
    <ChartContainer config={chartConfig} className="h-[200px] w-full">
      <AreaChart data={last30}>
        <defs>
          <linearGradient id="fillInscripciones" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0.05} />
          </linearGradient>
        </defs>
        <CartesianGrid vertical={false} />
        <XAxis
          dataKey="fecha"
          tickLine={false}
          axisLine={false}
          tickFormatter={(v) => v.slice(5)}
          interval="preserveStartEnd"
        />
        <YAxis tickLine={false} axisLine={false} />
        <ChartTooltip content={<ChartTooltipContent />} />
        <Area
          dataKey="total"
          type="monotone"
          stroke="#8b5cf6"
          fill="url(#fillInscripciones)"
          strokeWidth={2}
        />
      </AreaChart>
    </ChartContainer>
  )
}
